export default __webpack_public_path__ + "static/media/braekfast.66396e25.svg";